export const proPricing = {
  monthly: {
    amount: 4.99,
    currency: "USD",
    period: "month",
  },
  yearly: {
    amount: 29.99,
    currency: "USD",
    period: "year",
    discount: 50,
  },
} as const;

export const proFeatures = [
  "<strong>Unlimited</strong> workout tracking",
  "<strong>Lifetime</strong> data retention & export",
  //"Benchmark <strong>insights</strong>: compare with lifters your age in your area",
  "<strong>Private group</strong> access — workouts shared automatically",
  //"No commitment. <strong>Cancel anytime</strong>.",
] as const;

export const cancellationReasons = [
  {
    key: "other",
    label: "Don't ask",
    description: "I don't have time for this survey",
  },
  {
    key: "too_expensive",
    label: "Too expensive",
    description: "The price is too high for my budget",
  },
  {
    key: "missing_features",
    label: "Missing features",
    description: "I need features that aren't available",
  },
  {
    key: "switched_service",
    label: "Switched to another service",
    description: "I found a better alternative",
  },
  {
    key: "unused",
    label: "Not using it enough",
    description: "I don't use the app frequently",
  },
  {
    key: "customer_service",
    label: "Poor customer service",
    description: "I'm not satisfied with the support",
  },
  {
    key: "low_quality",
    label: "Quality issues",
    description: "The app doesn't meet my expectations",
  },
  {
    key: "too_complex",
    label: "Too complicated",
    description: "The app is difficult to use",
  },
] as const;

export const cancellationAlertMessage = [
  "You'll keep Pro until this billing period ends.",
  "After that, you'll move to the Free plan and lose Pro features (<strong>unlimited tracking</strong>, <strong>lifetime data retention</strong>, and <strong>private group access</strong>).",
  "When you downgrade, any training data older than 6 months will be <strong>permanently deleted</strong> and cannot be recovered, even if you re-subscribe.",
] as const;
